import CommonAutocomplete from "../../../../../components/CommonAutocomplete";
import IntersectionObservedView from "../../../../../components/IntersectionObservedView";

function PackingSelect({value, packings, onSelect, ...prop}) {

  return (
    <IntersectionObservedView
      rootMargin = "50px"
    >
      <CommonAutocomplete
        value={value}
        onSelect={(_e, value) => {
          onSelect(value)
        }}
        data={packings}
        filterOptions={(options, { inputValue }) => {
          return options.filter((option) => {
            return option.packingId?.toString().includes(inputValue);
          });
        }}
        optionLabel={(option) =>
          option ? option.packingId + " - " + option.packingName : ""
        }
        {...prop}
      />
    </IntersectionObservedView>
  );
}

export default PackingSelect;
